(function () {

  var parseKeys = function (keysString) {
    if (!keysString) {
      return [];
    }
    return keysString.split('|').filter(function (key) {
      return key;
    });
  };

  var buildUpdates = function (keys, qty) {
    var updates = {};
    keys.forEach(function (key) {
      updates[key] = qty;
    });
    return updates;
  };

  var postUpdates = function (updates) {
    return fetch('/cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      body: JSON.stringify({ updates: updates }),
    }).then(function () {
      window.location.reload();
    });
  };

  var applyBundleQty = function (keysString, qty) {
    var keys = parseKeys(keysString);
    if (!keys.length) {
      return;
    }
    postUpdates(buildUpdates(keys, qty));
  };

  document.addEventListener('click', function (event) {
    var removeButton = event.target.closest('.ts-bundle__remove');
    if (removeButton) {
      event.preventDefault();
      applyBundleQty(removeButton.dataset.bundleKeys, 0);
      return;
    }

    var updateButton = event.target.closest('.ts-bundle__update');
    if (updateButton) {
      event.preventDefault();
      var container = updateButton.closest('.ts-bundle__actions');
      var qtyInput = container ? container.querySelector('.ts-bundle__qty') : null;
      var qtyValue = qtyInput ? parseInt(qtyInput.value, 10) : 0;
      if (isNaN(qtyValue) || qtyValue < 0) {
        qtyValue = 0;
      }
      applyBundleQty(updateButton.dataset.bundleKeys, qtyValue);
    }
  });

  document.addEventListener('change', function (event) {
    var qtyInput = event.target.closest('.ts-bundle__qty');
    if (!qtyInput) {
      return;
    }

    var qtyValue = parseInt(qtyInput.value, 10);
    if (isNaN(qtyValue) || qtyValue < 0) {
      qtyValue = 0;
    }
    applyBundleQty(qtyInput.dataset.bundleKeys, qtyValue);
  });
})();
